import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { OpentokService } from '../home/opentok.service';

@Component({
  selector: 'app-home',
  templateUrl: './home-manises.component.html',
  styleUrls: ['./home-manises.component.css']
})
export class HomeManisesComponent implements OnInit {
  session: OT.Session;
  parts: FormGroup
  url: string
  isFormInvalid = true

  constructor(
    private opentokService: OpentokService,
    fb: FormBuilder
  ) { 
    this.parts = fb.group({
      telephone: ['', [this.telephoneValidator]],
      email: ['', this.emailValidator]
    }, {validator: this.oneFieldRequired});
  }

  ngOnInit(): void {
  }

  public doCreateRoom() {
    this.opentokService.doCreateRoom(
      'manises',
      this.parts.controls.telephone.value,
      this.parts.controls.email.value
    ).subscribe(
      response => this.successCreateRoom(response),
      fail => this.failCreateRoom(fail)
    );
  }

  public doReturn() {
    this.url = null;
  }

  public oneFieldRequired(formGroup): any {
    let telephone = formGroup.controls['telephone'].value;
    let email = formGroup.controls['email'].value;

    if (telephone.length > 0 || email.length > 0) {
      return null;
    } else {
      return { oneFieldRequired: true };
    }
  }

  private emailValidator(control: AbstractControl): ValidationErrors {
    if (!control.value || control.value.length == 0) {
      return null;
    }
  
    return Validators.email(control);
  }

  private telephoneValidator(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }
  
    return Validators.pattern('[0-9]{9}')(control);
  }

  /*public doEnterRoom() {
    this.opentokService.doOpenSession(this.url).subscribe(
      response => this.successEnterRoom(response),
      fail => this.failEnterRoom(fail)
    );
  }*/

  public doEnterRoom() {
    open(this.url);
  }

  public hasError(property: string, validation: string) {
    if (this.parts && this.parts.controls[property]) {
      return this.parts.controls[property].hasError(validation);
    }
  }

  public isDirty(property: string) {
    if (this.parts && this.parts.controls[property]) {
      return this.parts.controls[property].dirty;
    }
  }

  public isTouched(property: string) {
    if (this.parts && this.parts.controls[property]) {
      return this.parts.controls[property].touched;
    }
  }

  private successCreateRoom(response) {
    console.log(response);
    this.url = response.urlmedico;
  }

  private failCreateRoom(fail) {
    console.log(fail);
  }

  /*private successEnterRoom(response) {
    console.log(response);
    const session = this.opentokService.doInitSession(response.TB_sessionId);
    session.connect(response.token, () => {})
  }

  private failEnterRoom(fail) {
    console.log(fail);
  }

  private successInitSession(response) {
    console.log(response);
  }

  private failInitSession(fail) {
    console.log(fail)
  }
*/
}
